// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ilaBF","title":"styles_title__1hlUv"};